import React from 'react';
import PropTypes from 'prop-types';

var SvgContextMixin = require('./svgContextMixin'),
  SvgChartContextMixin = require('./svgChartContextMixin');

var SvgChartPolyLine = React.createClass({
  mixins: [SvgContextMixin, SvgChartContextMixin],

  statics: {
    userIconClipPath: "ChartUserIconClipPath",
    iconSize: 8,
    lineWidthScale: 1.25
  },

  propTypes: {
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    points: PropTypes.string.isRequired,
    stroke: PropTypes.string,
    strokeWidth: PropTypes.number,
    iconUrl: PropTypes.string,
    iconCenter: PropTypes.array
  },

  getDefaultProps(){
    return {
      stroke: "#000000",
      strokeWidth: 1.5,
      iconCenter: [0, 0]
    };
  },

  getInitialState(){
    return {
      isHovered: false
    };
  },

  render(){
    var {points, stroke, strokeWidth, iconUrl} = this.props;

    var min = this.context.getPoint(0, 0);

    var filter, lineWidth;

    if (this.state.isHovered) {
      filter = this.context.getLineShadowFilterUrl();
      lineWidth = SvgChartPolyLine.lineWidthScale * strokeWidth;
    } else {
      lineWidth = strokeWidth;
    }

    return (
      <g filter={filter}>
        <polyline
          points={ points }
          stroke={ stroke }
          strokeWidth={ lineWidth }
          fill="none"
          onMouseEnter={this._onLineIn}
          onMouseLeave={this._onLineOut}
        />
        <circle cx={min[0]} cy={min[1]} r="1" fill="none" stroke="none"/>
        ;
        {this._getPortrait()}
      </g>
    );
  },

  _onLineIn(){
    this.setState({isHovered: true});
  },

  _onLineOut(){
    this.setState({isHovered: false});
  },

  _getPortrait(){
    var {iconCenter, id, iconUrl} = this.props;

    if (!iconUrl || !this.state.isHovered) return null;

    var clipPath = this.context.linkTo(SvgChartPolyLine.userIconClipPath + id),
      size = this.context.relativeY(SvgChartPolyLine.iconSize),
      x = iconCenter[0] + size / 2,
      y = iconCenter[1];

    return (
      [
        <clipPath key={SvgChartPolyLine.userIconClipPath}
                  id={SvgChartPolyLine.userIconClipPath + id}>
          <circle cx={x - size} cy={y} r={size / 2}/>
        </clipPath>,
        <image
          onMouseEnter={this._onLineIn}
          onMouseLeave={this._onLineOut}
          key="icon"
          x={x - size * 3 / 2} y={y - size / 2}
          xlinkHref={iconUrl}
          height={size}
          width={size}
          clipPath={clipPath}
        />
      ]
    );
  }
});


module.exports = SvgChartPolyLine;
